import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CdkMenu, CdkMenuTrigger, CdkMenuItem,  } from '@angular/cdk/menu';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import {  HttpClient } from '@angular/common/http';
import { TemaService } from '../services/tema.services';
import { Subscription } from 'rxjs';
import { ScrollingModule } from '@angular/cdk/scrolling';


interface MenuItem {
  label: string;
  action: string;
  submenu?: MenuItem[];  // submenu de primer nivel
  submenu2?: MenuItem[]; // submenu de segundo nivel
  submenu3?: MenuItem[]; // submenu de tercer nivel
  submenu4?: MenuItem[]; // submenu de cuarto nivel
  submenu5?: MenuItem[]; // submenu de quinto nivel
  // Aquí puedes agregar más niveles si es necesario
}

@Component({
  selector: 'app-cdk-select',
  templateUrl: './cdk-select.component.html',
  styleUrl: './cdk-select.component.scss',
  encapsulation: ViewEncapsulation.None,
})
export class CdkSelectComponent implements OnInit, OnDestroy {


  @Input() menuDefinitivo: any[] = [];
  @Output() buttonClick: EventEmitter<{ label: string, isChecked: string, r:string }> = new EventEmitter();
  public subTheme : Subscription;
  isDark: boolean=false;

  onButtonClick(label: string, isChecked: string, r:string): void {
    console.log('Label:', label);
    console.log('Checkbox state:', isChecked);
    this.buttonClick.emit({ label, isChecked,r });
  }  

  constructor( public temaservicio: TemaService,){

  }

  ngOnInit(): void {
    this.subTheme = this.temaservicio.valDarkTheme.subscribe({
      next: (data: any)=>{
          this.isDark=data;
      }
  });
  }

  ngOnDestroy(): void {
    this.subTheme.unsubscribe();
  }

  searchIndicatorInChatGPT(nombreIndicador: string) {
    const selectedIndicator = 'Que es el indicador ' + nombreIndicador + "?, dame ejemplos de condiciones para señales con este indicador con los operadores: >, <,=, cruce, etc. y dame condicion en formato screener ";

    if (selectedIndicator) {
        // Construir la URL con el ítem seleccionado
        const query = encodeURIComponent(selectedIndicator);
        const url = `https://chat.openai.com/?q=${query}`;

        // Redirigir a la URL
        //window.location.href = url;
        window.open(url, '_blank');
    } else {
        console.warn('Por favor, seleccione un indicador antes de buscar.');
    }
}

}
